import { z } from 'zod'

const Problem = z.object({
  type: z.string().optional(),
  title: z.string().optional(),
  status: z.number().optional(),
  detail: z.string().optional(),
  instance: z.string().optional(),
})

// Lazy toast without hooking into context to avoid circular import
export function toastProblem(input: unknown) {
  const p = Problem.safeParse(input)
  const msg = p.success ? (p.data.title || 'Request failed') + (p.data.detail ? ` — ${p.data.detail}` : '') : 'Request failed'
  showMiniToast(msg)
}

function showMiniToast(message: string) {
  if (typeof document === 'undefined') return
  let stack = document.getElementById('problem-toast-stack')
  if (!stack) {
    stack = document.createElement('div')
    stack.id = 'problem-toast-stack'
    stack.setAttribute('role', 'status')
    stack.setAttribute('aria-live', 'polite')
    stack.className = 'fixed z-[2000] bottom-4 right-4 flex flex-col gap-2'
    document.body.appendChild(stack)
  }
  const toast = document.createElement('div')
  toast.className = 'max-w-md rounded border bg-white dark:bg-gray-900 shadow-elev-2 p-3 text-sm'
  toast.textContent = message
  stack.appendChild(toast)
  setTimeout(() => {
    toast.remove()
    if (!stack || stack.childElementCount === 0) {
      stack?.remove()
    }
  }, 3000)
}
